import { LoadingStatusType } from "@/enums/enums";
import { VuexModule, Module, Mutation, Action } from "vuex-module-decorators";
import API from "@/service/Index";
import { ToProductList } from "@/service/product/productFacade";

@Module({ namespaced: true })
export default class Contact extends VuexModule {
  public productListLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public productList: any = [];

  get getProductListLoadingStatus(): any {
    return this.productListLoadingStatus;
  }

  get getProductList(): any {
    return this.productList;
  }

  @Mutation
  public MutationSetProductListLoadingStatus(status: LoadingStatusType) {
    this.productListLoadingStatus = status;
  }

  @Mutation
  public MutationSetProductList(contactList: any) {
    this.productList = contactList;
  }

  @Action
  public DoGetAllProductTemplate(isUseMainDatabase = false) {
    if (this.productListLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("MutationSetProductListLoadingStatus", LoadingStatusType.Loading);
      API.ProductService.DoGetAllProductTemplate(isUseMainDatabase)
        .then((res) => {
          if (res.data.responseCode.IsSuccess()) {
            const productList = ToProductList(res.data.productList);
            this.context.commit("MutationSetProductList", productList);
          }
          this.context.commit("MutationSetProductListLoadingStatus", LoadingStatusType.Success);
        })
        .catch((error) => error);
    }
  }
}
